<script lang="ts">
  import { formatSecondsToDigitDisplay } from '../../../../utils/Time'

  type Props = {
    currentTime: number
    endTime: number
  }

  let { currentTime, endTime }: Props = $props()
</script>

<p class="absolute bottom-0 text-xs text-white shadow-sm mb-3 ml-0.5">
  {formatSecondsToDigitDisplay(currentTime)}
  <span class="text-white/35">/</span>
  {formatSecondsToDigitDisplay(endTime)}
</p>
